<template>
    <div class='productionRow'>
        <div class='content'>
            <div class="title">产品介绍</div>
            <div class="subtitle">加强党建引领，社区工作展示，社区共治共享</div>
        </div>
        <div class='content box productContent1'>
            <div class="productItem" v-for="(item,index) in datalist1" :key="index">
                <img class="productImg" :src="item.logo"/>
                <div class="productName">{{item.title}}</div>
                <div class="productSubName">{{isPhone?item.row1+"，"+item.row2:item.row1}}</div>
                <div class="productSubName" v-if="!isPhone">{{item.row2}}</div>
                <div class="productSubName">{{item.row3}}</div>
            </div>
        </div>
        <div class='content box productContent2'>
            <div class="productItem" v-for="(item,index) in datalist2" :key="index">
                <img class="productImg" :src="item.logo"/>
                <div class="productName">{{item.title}}</div>
                <div class="productSubName">{{isPhone?item.row1+"，"+item.row2:item.row1}}</div>
                <div class="productSubName" v-if="!isPhone">{{item.row2}}</div>
                <div class="productSubName">{{item.row3}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        isPhone:{
            type:Boolean,
            default:false
        }
    },
    data() {
    //这里存放数据
        return {
            datalist1:[{
                        logo:require('../../../assets/images/showProduct/advance1.png'),
                        title:"加强党建引领",
                        row1:"发挥党员带头作用",
                        row2:"组织党员活动",
                        row3:"开展党员学习"
                    },{
                        logo:require('../../../assets/images/showProduct/advance2.png'),
                        title:"社区工作展示",
                        row1:"居民了解社区动态",
                        row2:"优秀党员及志愿者风采展示",
                        row3:"社区工作深入基层"
                    },{
                        logo:require('../../../assets/images/showProduct/advance3.png'),
                        title:"社区共治共享",
                        row1:"居民反应问题",
                        row2:"邻里限制共享",
                        row3:"加强社区文化建设"
                    }],
            datalist2:[{
                        logo:require('../../../assets/images/showProduct/advance4.png'),
                        title:"社区协同工作",
                        row1:"发挥社区监督职能",
                        row2:"联合公服企业",
                        row3:"共建美好社区"
                    },{
                        logo:require('../../../assets/images/showProduct/advance5.png'),
                        title:"丰富社区活动",
                        row1:"开展社区活动",
                        row2:"周边商家上门服务",
                        row3:"最新政策咨询"
                    }]
        };
    },
}
</script>

<style src="../pc.css" scoped></style>
<style src="../phone.css" scoped></style>

